import { createBrowserRouter, useLocation, useSearchParams } from "react-router-dom";
// import { lazy } from "react";
// import { Box, CircularProgress } from "@mui/material";
// import { Suspense } from "react";
import Login from "../pages/Login";
import FullLayout from "../layouts/FullLayout/FullLayout";
import Dashboard from "../pages/Dashboard";

import {
  ACCOUNT_ADD_TRANSACTION_ROUTE,
  ACCOUNT_ADVANCED_SALARY_ROUTE,
  ACCOUNT_DASHBOARD,
  ACCOUNT_DEALS_ROUTE,
  ACCOUNT_EXPENSES_ROUTE,
  ACCOUNT_PAYROLL_ROUTE,
  ADD_AGENT_ROUTE,
  ADD_LEAD_ROUTE,
  ADD_PROPERTY_ROUTE,
  AGENTS_ROUTE,
  APPOINTMENT_ROUTE,
  ATTENDANCE,
  All_LEADS_ROUTE,
  CONTACTS_ROUTE,
  HISTORY_ROUTE,
  DEAL_DEAL_ROUTE,
  EDIT_AGENT_ROUTE,
  EDIT_LEAD_ROUTE,
  EDIT_PROPERTY_ROUTE,
  INTEGRATION_HUB,
  LEADS_POOL_ROUTE,
  LEADS_ROUTE,
  LEAD_AGENT_ROUTE,
  LIVE_TRACKING,
  PACKAGES,
  PROFILE_ROUTE,
  PROPERTIES_ROUTE,
  REPORTS,
  ROLES_ROUTE,
 
  SALARY_DASHBOARD,
 
  TASKS_ROUTE,
  TRANSACTION_DETAILS_ROUTE,
  VENDOR,
  VIEWING_DONE_ROUTE,
  VIEW_DETAILS_ROUTE,
  VIEW_ROUTE,
  XML_FEED,
  FACEBOOK_PAGES,
  FACEBOOK_CONNECTED,
} from "../constants/routes";
import Agents from "../pages/Agents";
import Properties from "../pages/Properties";
import AddAgent from "../pages/Agents/AddAgent";
import Profile from "../pages/Profile";
import RequireAuth from "../components/RequireAuth";
import EditProperty from "../pages/Properties/EditProperty";
import Signup from "../pages/Signup";
import EditAgent from "../pages/Agents/EditAgent";
import Leads from "../pages/Leads";
import AddLead from "../pages/Leads/AddLead";
import EditLead from "../pages/Leads/EditLead";
import { Box, CircularProgress } from "@mui/material";
import { selectCurrentagency } from "../redux/features/authSlice";
import { useSelector } from "react-redux";
import { useGetAgencyPropertiesQuery } from "../redux/api/propertiesApi";
import { PropertiesData } from "../hooks/useContext/agencyProperties";
import { LeadsData } from "../hooks/useContext/leadsData";
import { useGetLeadsQuery } from "../redux/api/leadsApi";
import { Suspense } from "react";
import ViewLead from "../pages/Leads/lead/ViewLead";
import LeadDetails from "../pages/Leads/lead/LeadDetails";
import History from "../pages/Leads/lead/History";
import ViewingArranged from "../pages/Leads/lead/status/ViewingArranged";
import ViewingDone from "../pages/Leads/lead/status/ViewingDone";
import Deal from "../pages/Leads/lead/status/deal/Deal";
import { DealsPdf } from "../pages/Accounts/deals/Deals";
import Contacts from "../pages/Contacts";
import AddProperty from "../pages/Properties/AddProperty";
import { AddTransaction } from "../pages/Accounts/deals/AddTransaction";
import { TransactionDetails } from "../pages/Accounts/deals/TransactionDetails";
import ForgetPassword from "../pages/ResetPassword";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import LeadPool from "../pages/Leads/LeadPool";
import AllLead from "../pages/Leads/AllLeads";
import Tasks from "../pages/Tasks";
import Roles from "../pages/Settings/index";
import XmlFeed from "../pages/XmlFeed";
import Expenses from "../pages/Accounts/Expenses/Expenses";
import Salary from "../pages/Accounts/Salary/Salary";
import AdvancedSalary from "../pages/Accounts/AdvancedSalary/AdvancedSalary";
import IncomeReportPage from "../pages/Accounts/IncomReports/IncomReports";
import PackageSelection from "../pages/Accounts/Packages/Packages";
import Attendance from "../pages/Accounts/Attendance/Attendance";
import AccountsDashboard from "../pages/Accounts/AccountsDashboard/AccountDashboard";
import SalarySheet from "../pages/Accounts/SalarySheet/SalarySheet";
import Vendor from "../pages/Accounts/Vendor/Vendor";
import AgentTracking from "../pages/GPS";
import IntegrationHub from "../pages/IntegrationHub";
import FacebookConnectPage from "../pages/IntegrationHub/ConnectFB";
import FacebookConnected from "../pages/IntegrationHub/FacebookConnected";

const SuspenseLayout = ({ children }) => {
  const DataProvider = ({ children }) => {
      const location = useLocation();

  const [searchParams] = useSearchParams(); 
  const isPropertiesRoute = location.pathname === "/properties";

 const rawStatus = searchParams.get("status");
    const rawPage = searchParams.get("page");  // already 1-based from your router
    const rawSize = searchParams.get("size");

    const propstat =
      rawStatus === null ? undefined : rawStatus === "all" ? "all" : Number(rawStatus);

    const pageNumber = rawPage ? Number(rawPage) : undefined;  // pass as-is
    const pageSize = rawSize ? Number(rawSize) : undefined;

    const currentAgency = useSelector(selectCurrentagency);
  

 const queryArgs = isPropertiesRoute
      ? {
          agencyId: currentAgency.agencyid,
          propstat,
          pageNumber,
          pageSize
        }
      : undefined;

       const { data: properties = [], isLoading, refetch: isRefetch } = useGetAgencyPropertiesQuery(
      queryArgs,
      { skip: !isPropertiesRoute }
    );


    const {
      data: agencyLeads = [],
      isLoading: LeadsLoading,
      refetch,
    } = useGetLeadsQuery(currentAgency.agencyid);

    return (
      <PropertiesData.Provider value={{ properties, isLoading, isRefetch }}>
        <LeadsData.Provider value={{ agencyLeads, LeadsLoading, refetch }}>
          {children}
        </LeadsData.Provider>
      </PropertiesData.Provider>
    );
  };
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      }
    >
      <DataProvider>{children}</DataProvider>
    </Suspense>
  );
};

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  { path: "/signup", element: <Signup /> },
  { path: "/forget-password", element: <ForgetPassword /> },
  { path: "/Agency/TokenVerification", element: <ResetPassword /> },
  {
    path: "/",
    element: (
      <RequireAuth>
        <FullLayout />
      </RequireAuth>
    ),
    errorElement: <div>Page Not Found</div>,
    children: [
      { path: "/", element: <Dashboard /> },
      {
        path: PROPERTIES_ROUTE,
        element: (
          <SuspenseLayout>
            <Properties />
          </SuspenseLayout>
        ),
      },
      {
        path: ADD_PROPERTY_ROUTE,
        element: (
          <SuspenseLayout>
            <AddProperty />
          </SuspenseLayout>
        ),
      },
      {
        path: AGENTS_ROUTE,
        element: <Agents />,
      },
      {
        path: ADD_AGENT_ROUTE,
        element: <AddAgent />,
      },
      {
        path: PROFILE_ROUTE,
        element: <Profile />,
      },
      {
        path: EDIT_PROPERTY_ROUTE + ":propertyId",
        element: <EditProperty />,
      },

      {
        path: EDIT_AGENT_ROUTE + ":agentId",
        element: <EditAgent />,
      },

      {
        path: LEADS_ROUTE,
        element: (
          <SuspenseLayout>
            <Leads />
          </SuspenseLayout>
        ),
      },
      {
        path: ADD_LEAD_ROUTE,
        element: <AddLead />,
      },
      {
        path: EDIT_LEAD_ROUTE + ":leadId",
        element: (
          <SuspenseLayout>
            <EditLead />
          </SuspenseLayout>
        ),
      },
      {
        path: LEAD_AGENT_ROUTE,
        element: (
          <SuspenseLayout>
            <ViewLead />
          </SuspenseLayout>
        ),
      },
      {
        path: All_LEADS_ROUTE,
        element: (
          <SuspenseLayout>
            <AllLead />
          </SuspenseLayout>
        ),
      },
      {
        path: LEAD_AGENT_ROUTE + VIEW_ROUTE + APPOINTMENT_ROUTE,
        element: (
          <SuspenseLayout>
            <ViewingArranged />
          </SuspenseLayout>
        ),
      },
      {
        path: LEAD_AGENT_ROUTE + VIEW_ROUTE + VIEWING_DONE_ROUTE,
        element: (
          <SuspenseLayout>
            <ViewingDone />
          </SuspenseLayout>
        ),
      },
      {
        path: LEAD_AGENT_ROUTE + VIEW_ROUTE + DEAL_DEAL_ROUTE,
        element: (
          <SuspenseLayout>
            <Deal />
          </SuspenseLayout>
        ),
      },
      {
        path: LEAD_AGENT_ROUTE + VIEW_ROUTE + VIEW_DETAILS_ROUTE,
        element: (
          <SuspenseLayout>
            <LeadDetails />
          </SuspenseLayout>
        ),
      },
      {
        path: LEAD_AGENT_ROUTE + VIEW_ROUTE + HISTORY_ROUTE,
        element: (
          <SuspenseLayout>
            <History />
          </SuspenseLayout>
        ),
      },
      {
        path: LIVE_TRACKING,
        element: (
          <SuspenseLayout>
            <AgentTracking />
          </SuspenseLayout>
        ),
      },
      {
        path: CONTACTS_ROUTE,
        element: (
          <SuspenseLayout>
            <Contacts />
          </SuspenseLayout>
        ),
      },
        {
        path: VENDOR,
        element: (
          <SuspenseLayout>
            <Vendor />
          </SuspenseLayout>
        ),
      },
      {
        path: ACCOUNT_DEALS_ROUTE,
        element: (
          <SuspenseLayout>
            <DealsPdf />
          </SuspenseLayout>
        ),
      },

      {
        path: ACCOUNT_EXPENSES_ROUTE,
        element: (
          <SuspenseLayout>
            <Expenses />
          </SuspenseLayout>
        ),
      },
      {
        path: ACCOUNT_PAYROLL_ROUTE,
        element: (
          <SuspenseLayout>
            <Salary />
          </SuspenseLayout>
        ),
      },

      {
        path: ACCOUNT_ADVANCED_SALARY_ROUTE,
        element: (
          <SuspenseLayout>
            <AdvancedSalary />
          </SuspenseLayout>
        ),
      },

      {
        path: INTEGRATION_HUB,
        element: (
          <SuspenseLayout>
            <IntegrationHub />
          </SuspenseLayout>
        ),
      },
      {
        path: REPORTS,
        element: (
          <SuspenseLayout>
            <IncomeReportPage />
          </SuspenseLayout>
        ),
      },
      {
        path: PACKAGES,
        element: (
          <SuspenseLayout>
            <PackageSelection />
          </SuspenseLayout>
        ),
      },
      {
        path: ATTENDANCE,
        element: (
          <SuspenseLayout>
            <Attendance />
          </SuspenseLayout>
        ),
      },
      {
        path: ACCOUNT_DASHBOARD,
        element: (
          <SuspenseLayout>
            <AccountsDashboard />
          </SuspenseLayout>
        ),
      },
      {
        path:SALARY_DASHBOARD ,
        element: (
          <SuspenseLayout>
            <SalarySheet />
          </SuspenseLayout>
        ),
      },
      {
        path:FACEBOOK_PAGES ,
        element: (
            <FacebookConnectPage />
        ),
      },
      {
        path: FACEBOOK_CONNECTED,
        element: <FacebookConnected />,
      },

      {
        path: TRANSACTION_DETAILS_ROUTE + "/:dealId",
        element: (
          <SuspenseLayout>
            <TransactionDetails />
          </SuspenseLayout>
        ),
      },
      {
        path: ACCOUNT_ADD_TRANSACTION_ROUTE + ":dealId" + "/:transactionId",
        element: (
          <SuspenseLayout>
            <AddTransaction />
          </SuspenseLayout>
        ),
      },
      {
        path: LEADS_POOL_ROUTE,
        element: (
          <SuspenseLayout>
            <LeadPool />
          </SuspenseLayout>
        ),
      },
      {
        path: TASKS_ROUTE,
        element: (
          <SuspenseLayout>
            <Tasks />
          </SuspenseLayout>
        ),
      },
      {
        path: ROLES_ROUTE,
        element: (
          <SuspenseLayout>
            <Roles />
          </SuspenseLayout>
        ),
      },
      {
        path: XML_FEED,
        element: (
          <SuspenseLayout>
            <XmlFeed />
          </SuspenseLayout>
        ),
      },
    ],
  },
]);